import { render } from "./SavedCardsSet.vue?vue&type=template&id=508f4636"
import script from "./SavedCardsSet.vue?vue&type=script&lang=js"
export * from "./SavedCardsSet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__